import { paginationStyles } from "@insite/content-library/Widgets/MyLists/MyListsPagination";
import { getMgbwPaginationOverrides } from "@tSurya/Common/Utilities/mgbwPaginationOverrides";

paginationStyles.pagination = getMgbwPaginationOverrides();
